import { render, staticRenderFns } from "./Startseite4.vue?vue&type=template&id=665579a4&scoped=true&"
import script from "./Startseite4.vue?vue&type=script&lang=js&"
export * from "./Startseite4.vue?vue&type=script&lang=js&"
import style0 from "./Startseite4.vue?vue&type=style&index=0&id=665579a4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665579a4",
  null
  
)

export default component.exports